import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import FiltersComponent from '../utils/filters';
import { useManagerFilters } from './helpers/useManagerFilters';
import State from '../app/store/state';
import { Filter } from '../utils/FilterTypes';

interface Props {
    setShowStartDateColumn: (showStartDateColumn: boolean) => void;
}

export function ManagerFilters({ setShowStartDateColumn }: Props) {
    const [activeFilters, setActiveFilters] = useState<Filter[]>([]);
    const { filters, handleApplyFilters } = useManagerFilters();
    const sortingOrder = useSelector((state: State) => state.managers.sortingOptions);

    useEffect(() => {
        handleApplyFilters(activeFilters);
    }, [sortingOrder]);

    const handleChangeFilters = (filters: Filter[]) => {
        const statusFilter = filters.find((filter) => filter.name === 'status');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const isFutureUsersOption = !!(statusFilter?.value as any)?.find((option) => option.value === 'future');

        setShowStartDateColumn(isFutureUsersOption);
        setActiveFilters(filters);
        handleApplyFilters(filters);
    };

    return (
        <FiltersComponent
            defaultFilters={filters}
            filters={filters}
            onApplyFilters={handleChangeFilters}
            withApply
            withIsSelected
        />
    );
}
